import type { MouseEvent } from "react";

import type { AppView } from "./types";

export const REVIEW_RUNS_URL = "/?view=github-reviews";
export const CODEX_URL = "/?view=github-reviews&section=codex";

export function getCodexRuleUrl(ruleId: string): string {
  return `${CODEX_URL}&rule=${encodeURIComponent(ruleId)}`;
}

export function clearReviewRouteParams(url: URL): void {
  url.searchParams.delete("section");
  url.searchParams.delete("rule");
}

export function navigateReviewLink(
  event: MouseEvent<HTMLAnchorElement>,
  href: string,
  view: Extract<AppView, "github-reviews" | "github-reviews-codex" | "github-reviews-codex-rule">,
  setView: (view: AppView) => void,
): void {
  if (event.button !== 0 || event.metaKey || event.ctrlKey || event.shiftKey || event.altKey)
    return;
  event.preventDefault();
  window.history.pushState({}, "", href);
  setView(view);
}
